<template>
  <ul>
    <li v-for="link in data.links">
      <a :href="link.url">{{ link.linkTitle }}</a><br>{{ link.description }}
    </li>
  </ul>
</template>

<script>

  export default {
    name: 'ContentModuleAudio',
    props: {
      data: {
        type: Object,
        required: true
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  ul {
    @include list-style-reset;
  }

  li + li {
    margin-top:2rem;
  }

  a {
    color:$color-primary; text-decoration:none;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/content-module/research-links.vue